import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import TrainingDataCreateEditForm from './Components/TrainingDataCreateEditForm';
import TrainingDataApi from './TrainingDataApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: TrainingDataCreateEditForm,
                getCreate: TrainingDataApi.create,
                defaults: {},
                successMessage: "TrainingData Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}